var getRequestUrl = function getRequestUrl(fetchInput) {
  return typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
};
export { getRequestUrl };